<label class="searchbox" [class.dirty]="!!searchInput.value" (click)="checkContext($event)">
  <input
    #searchInput
    [placeholder]="'searchBox.placeholder' | cxTranslate"
    aria-label="search"
    (focus)="open()"
    (click)="open()"
    (input)="search(searchInput.value)"
    (blur)="closeme();close($event)"
    (keydown.escape)="closeme();close($event)"
    (keydown.enter)="
    closeme();close($event); launchSearchResult(searchInput.value); updateChosenWord(searchInput.value)"
    (keydown.arrowup)="focusPreviousChild($event)"
    (keydown.arrowdown)="focusNextChild($event)"
    value="{{ chosenWord }}"
    [disabled]="!customerContext"
    />

    <cx-icon
      [type]="iconTypes.RESET"
      aria-label="reset"
      (mousedown)="clear(searchInput); clearIcon()"
      (keydown.enter)="clear(searchInput); clearIcon()"
      class="reset header-icon-color"
      tabindex="0"
    ></cx-icon>

    <cx-icon
      [type]="iconTypes.SEARCH"
      aria-label="search"
      class="search header-icon-color"
      (mousedown)="avoidReopen($event)"
      (keydown.enter)="avoidReopen($event)"
      tabindex="0"
    ></cx-icon>
  </label>

  @if (isOpen && results$ | async; as result) {
    <div class="results" [ngClass]="{ 'active': isactive }" (click)="close($event)">
      @if (result.message) {
        <div class="message" [innerHTML]="result.message"></div>
      }
      <div class="suggestions">
        @for (suggestion of result.suggestions; track suggestion) {
          <a
            [innerHTML]="suggestion | cxHighlight: searchInput.value"
      [routerLink]="
        {
          cxRoute: 'search',
          params: { query: suggestion }
        } | cxUrl
      "
            (keydown.arrowup)="focusPreviousChild($event)"
            (keydown.arrowdown)="focusNextChild($event)"
            (keydown.enter)="close($event)"
            (keydown.escape)="close($event)"
            (blur)="close($event)"
            (mousedown)="preventDefault($event)"
      (click)="
        dispatchSuggestionEvent({
          freeText: searchInput.value,
          selectedSuggestion: suggestion,
          searchSuggestions: result.suggestions
        });
        updateChosenWord(suggestion)
      "
            >
          </a>
        }
      </div>
      @if (result.products) {
        <div class="products">
          @for (product of result.products; track product) {
            <a class="product-alignment"
      [routerLink]="
        {
          cxRoute: 'product',
          params: product
        } | cxUrl
      "
              [class.has-media]="config.displayProductImages"
              (keydown.arrowup)="focusPreviousChild($event)"
              (keydown.arrowdown)="focusNextChild($event)"
              (keydown.enter)="close($event)"
              (keydown.escape)="close($event)"
              (blur)="close($event)"
              (mousedown)="preventDefault($event)"
      (click)="
        dispatchProductEvent({
          freeText: searchInput.value,
          productCode: product.code
        })
      "
              >
              @if (config.displayProductImages) {
                <cx-media
                  [container]="product.images?.PRIMARY"
                  format="thumbnail"
                  [alt]="product.summary"
                ></cx-media>
              }
              <div>
                <h4 class="name" [innerHTML]="product.nameHtml"></h4>
                <span class="price">{{ product.price?.formattedValue }}</span>
              </div>
            </a>
          }
        </div>
      }
    </div>
  }
